import React, { useState } from 'react';

const webDevTabsData = [
  {
    id: 'custom-website-dev',
    title: 'Custom Website Development',
    contentTitle: 'Custom Website Development',
    intro: (
      <>
        A custom website is one that is created especially for a certain company or person in accordance with their particular needs, objectives, and brand identity. We <a href="/web-design/" className="webdev-red-link">design custom websites</a> with performance, security, and flexibility. From engaged dashboards to interactive user experiences, we guarantee that each component is in line with your business model. It could be a service-based business, a digital marketplace, or an informative platform; we provide functional, responsive solutions that can be scaled for future expansion.
      </>
    )
  },
  {
    id: 'ecommerce-web-design',
    title: 'Ecommerce Web Design',
    contentTitle: 'Ecommerce Web Design',
    intro: (
      <>

        E-commerce is one of the growing business solutions in Pakistan; therefore, having a functioning, professional, and secure e-commerce website is sometimes difficult. Expert Communication provides <a href="/ecommerce-web-development/" className="webdev-red-link">e-commerce web development services</a> that combine practicality with innovative features to ensure your store’s success. Our team creates fast-loading product sites, secure checkout systems, and user-friendly layouts. We create websites for e-commerce, applying solutions such as Woo Commerce, Shopify, and custom frameworks that meet your company’s objectives.
      </>
    )
  },
  {
    id: 'wordpress-dev',
    title: 'WordPress Website Development',
    contentTitle: 'WordPress Website Development',
    intro: (
      <>

        <a href="https://wordpress.com/" target="_blank" rel="noopener noreferrer" className="webdev-red-link">WordPress</a> is one of the most popular website-building systems due to its flexibility, convenience of use, and extensive plugin infrastructure. We provide WordPress website development services for groups and companies who are interested in smoothly managing content concerning style and speed.
        We are excellent at creating custom WordPress themes, optimizing plugin usage, and website security. Our professional developers know how to maintain the balance between friendly interfaces and backend performance. We provide custom-made WordPress solutions that represent your brand. No matter if you are looking to build a blog, portfolio, company website, or online store.
      </>
    )
  },
  {
    id: 'frontend-dev',
    title: 'Front-end Development',
    contentTitle: 'Front-end Development',
    intro: (
      <>
        First look at the client to your website matters. The front-end of your website is what your consumers see and depend on, so it has to be simple, fascinating, and quick to load. It includes graphics and images, little modeling, or Photoshop. With the usage of HTML5, CSS3, and frameworks such as React and Vue.js, our developers make your ideas true. From animation, dynamic content, to a mobile-first layout, we provide front-end web development services that generate neat code, flexible layouts, and optimal performance.
      </>
    )
  },
  {
    id: 'backend-dev',
    title: 'Back-end Development',
    contentTitle: 'Back-end Development',
    intro: (
      <>
        Back-end web development is the server-side logic that runs a website or online application. It includes databases, servers, APIs, and application logic. Every dependable website has a well-structured backend that manages data flow, user interaction, and security. Our back-end services for web development are focused on creating an outstanding architecture that ensures your site functions properly under every circumstance. Our backend services are recommended for web development agencies in Karachi and around Pakistan who need to process large amounts of data or create complicated systems.
      </>
    )
  },
  {
    id: 'fullstack-dev',
    title: 'Full-stack Development',
    contentTitle: 'Full-stack Development',
    intro: (
      <>
        We handle the charge of everything, including database administration, APIs, backend integration, and UI/UX design. A simpler development, faster delivery, and fewer communication errors are all made possible by this one-stop solution. Our full-stack development services provide improved control and project flow if you’re creating a booking system, company site, or platform with unique capabilities.
      </>
    )
  }
];

function WebDevelopmentTabs() {
  const [activeTabId, setActiveTabId] = useState('custom-website-dev');

  const activeService =
    webDevTabsData.find((item) => item.id === activeTabId) || webDevTabsData[0];

  return (
    <section className="webdev-tabs-section">
      <div className="container">
        {/* Section Header: Main Heading on Left, Paragraph on Right */}
        <div className="webdev-tabs-header-row">
          <div className="webdev-tabs-header-left">
            <h2 className="webdev-tabs-main-title">
              Comprehensive web development services for your business
            </h2>
          </div>
          <div className="webdev-tabs-header-right">
            <p className="webdev-tabs-header-desc">
              In today’s fast digital world, navigating the landscape of web development and digital technology is essential for businesses that focus on scalable growth, exceptional performance, and engaging online experiences.
            </p>
          </div>
        </div>

        {/* Tabs & Content Layout */}
        <div className="webdev-tabs-main-grid">
          {/* Left Side: Dark Vertical Sidebar Tabs */}
          <div className="webdev-tabs-sidebar">
            <ul className="webdev-tabs-list">
              {webDevTabsData.map((item) => {
                const isActive = item.id === activeTabId;
                return (
                  <li key={item.id} className="webdev-tab-item">
                    <button
                      className={`webdev-tab-button ${isActive ? 'active' : ''}`}
                      onClick={() => setActiveTabId(item.id)}
                    >
                      {item.title}
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Right Side: Tab Content Card */}
          <div className="webdev-tab-content-card">
            <h3 className="webdev-tab-content-heading">
              {activeService.contentTitle}
            </h3>

            <p className="webdev-tab-content-intro">
              {activeService.intro}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WebDevelopmentTabs;
